import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarVendedorComponent } from '../../shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import { ModalAsignarClienteComponent } from './modal-asignar-cliente/modal-asignar-cliente.component';
import { ModalGenerarIptComponent } from './modal-generar-ipt/modal-generar-ipt.component';
import { ModalMarcadoMasivoComponent } from './modal-marcado-masivo/modal-marcado-masivo.component';
import { ModalTransferenciaClienteVendedorComponent } from './modal-transferencia-cliente-vendedor/modal-transferencia-cliente-vendedor.component';
import { debounceTime, filter } from 'rxjs/operators';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { IptPanelComponent } from '../../shared/ipt-panel/ipt-panel.component';

import * as _ from 'lodash'
import { throwToolbarMixedModesError } from '@angular/material';

@Component({
  selector: 'app-traspaso-masivo-cliente',
  templateUrl: './traspaso-masivo-cliente.component.html',
  styleUrls: ['./traspaso-masivo-cliente.component.scss'],
  providers: [SecurityService]
})
export class TraspasoMasivoClienteComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: ModalSeleccionarVendedorComponent
  @ViewChild(ModalAsignarClienteComponent, { static: true }) modalAsignarCliente: ModalAsignarClienteComponent
  @ViewChild(ModalGenerarIptComponent, { static: true }) modalGenerarIPT: ModalGenerarIptComponent
  @ViewChild(ModalMarcadoMasivoComponent, { static: true }) modalMarcadoMasivo: ModalMarcadoMasivoComponent
  @ViewChild(ModalTransferenciaClienteVendedorComponent, { static: true }) modalTrasnferenciaClienteVendedor: ModalTransferenciaClienteVendedorComponent
  @ViewChild(IptPanelComponent, { static: false }) child: IptPanelComponent;

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  private usuarioDeclaracionRut: number
  clienteSeleccionado: any = null
  vendedorSeleccionado: any = null
  loading: boolean = false
  listaMovimientos: Array<any> = null
  listaMovimientosAll: Array<any> = null
  areSelected: boolean = false
  selected: any[]
  paginationContext: PaginationContext = new PaginationContext()


  // Utils
  private log: any
  diasSemana: any;
  sharedVar: any;
  CodeVendedorSend: any;
  ClientesSeleccion: Array<any> = [];
  rutVendedor: any;
  enableIPT: any;
  seleccionForTraspasoMasivo: Array<any> = [];

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private clienteProveedorService: ClienteProveedorService,
  ) {
    this.log = this.clog.log('TRAPASO-MASIVO-CLIENTES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10

    this.createForms();
    this.formChangesSubscriptions()
  }

  receiveMessage($event) {
    this.diasSemana = $event
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rutVendedor: [null, []],
      rutCliente: [null, []],
      activo: [false, [Validators.required]],
      clientes_asig: [null, [Validators.required]],
      sucursales_asig: [null, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutVendedor").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutVendedor: string) => {
        this.modalSeleccionarVendedor.searchByRut(rutVendedor)
      })

    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
      })
  }

  /********* MODAL VENDEDOR *********/
  openModalSeleccionarVendedor() {
    this.modalSeleccionarVendedor.show()
  }

  onVendedorSeleccionado({ data }) {
    this.vendedorSeleccionado = data
    this.formHeader.get('rutVendedor').setValue(this.rutService.AgregarDV(this.vendedorSeleccionado.rut))
    // this.accesolocalstorage.setrutVendedor(this.formHeader.get("rutVendedor").value)
    this.CodeVendedorSend = data.codigo
    this.rutVendedor = this.formHeader.get('rutVendedor').value
  }

  onVendedorNoEncontrado() {
    this.vendedorSeleccionado = null
    this.clearData()
  }
  /********* MODAL VENDEDOR *********/


  /********* MODAL CLIENTE *********/
  openModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data
    this.formHeader.get('rutCliente').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut))
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
  }
  /********* MODAL CLIENTE *********/


  clearData() {
    this.areSelected = false
    this.selected = []
    this.loading = false
    this.listaMovimientos = null
    this.listaMovimientosAll = null

    this.paginationContext.CurrentPage = 1
  }

  showModalAsignarCliente() {
    this.modalAsignarCliente.show()
  }

  showModalGenerarIPT() {
    this.modalGenerarIPT.load(this.rutVendedor)
  }

  showModalMarcadoMasivo() {
    this.modalMarcadoMasivo.load()
  }

  showModalTrasnferenciaClienteVendedor() {
    this.modalTrasnferenciaClienteVendedor.load(this.rutVendedor)
  }

  Buscar(pageNumber: number = 1) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    // const detailsData = this.detallesComponent.data$
    // const { item } = detailsData
    // console.log(detailsData);

    const rOk = this.vendedorSeleccionado !== null
    if (!rOk) {
      this.toastrService.error("Debe seleccionar un vendedor")
      return
    } else {


      this.paginationContext.CurrentPage = pageNumber

      this.loading = true
      this.listaMovimientos = []
      this.listaMovimientosAll = []

      const inputParams = {
        entidad: {
          empresa_rut: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          codigo_vendedor: this.vendedorSeleccionado.codigo,
          rut: this.rutService.QuitarDV((parseInt(this.formHeader.get('rutCliente').value) || 0).toString()),
          activo: Boolean(this.formHeader.get('activo').value),
          lunes: Boolean(this.diasSemana[0].checked),    //lunes
          martes: Boolean(this.diasSemana[1].checked),   //martes
          miercoles: Boolean(this.diasSemana[2].checked), //miercoles
          jueves: Boolean(this.diasSemana[3].checked),    //jueves
          viernes: Boolean(this.diasSemana[4].checked),   //viernes
          sabado: Boolean(this.diasSemana[5].checked),    //sabado
          domingo: Boolean(this.diasSemana[6].checked)   //domingo
        },
        paginaActual: this.paginationContext.CurrentPage,
        cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
      }

      this.log('inputParams', JSON.stringify(inputParams))

      this.loading = true
      this.clienteProveedorService.obtenerClienteTraspaso(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          this.loading = false
          return
        }

        const { registros } = respuesta

        //* DATOS A ENVIAR A MARCACION MASIVA
        const dato = registros.map(cliente => {
          cliente.rutFormato = this.rutService.AgregarDV(cliente.rut)
          // cliente.checked = false
          this.removeElementTypename(cliente)
          const params = {
            empresa_rut: cliente.empresa_rut,
            codigo_vendedor: cliente.codigo_vendedor,
            rut: cliente.rut,
            nombre: cliente.razon_social,
            activo: cliente.activo,
            codigo_direccion: cliente.codigo_direccion,
            direccion_completa: cliente.direccion_completa,
            nombrecomuna: cliente.nombrecomuna,
            nombreprovincia: cliente.nombreprovincia,
            ruta_codigo: cliente.ruta_codigo,
            ruta_nombre: cliente.ruta_nombre,
            territorio_codigo: cliente.territorio_codigo,
            tipo_cliente_codigo: cliente.tipo_cliente_codigo,
            tipo_cliente_nombre: cliente.tipo_cliente_nombre,
            seleccion: false,
            lunes: cliente.lunes,
            martes: cliente.martes,
            miercoles: cliente.miercoles,
            jueves: cliente.jueves,
            viernes: cliente.viernes,
            sabado: cliente.sabado,
            domingo: cliente.domingo,
          }

          return params
        });
        this.seleccionForTraspasoMasivo = dato

        this.listaMovimientosAll = registros
        this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
        this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
        this.paginationContext.CurrentPage = 1

        this.listaMovimientosAll.forEach(p => {
          p.rutFormato = this.rutService.AgregarDV(p.rut)
        })

        this.listaMovimientosAll.forEach((mov, index) => {
          mov.additionalInfo = {}
          mov.additionalInfo.index = index
          mov.additionalInfo.checked = false

          mov.envio_rec = true // TODO: Remove this line. It exists is only for dev purposes
        });

        this.enableIPT = true;
        this.loading = false
        this.showPage(this.paginationContext.CurrentPage)
      })

    }


  }


  //* actualizar grilla desde generacion de IPT // ASIGNACION CLIENTE // MARCACION MASIVA
  UpdGrilla() {
    this.ClientesSeleccion = [];
    this.listaMovimientos = [];
    this.listaMovimientosAll = [];
    this.checkAllChange({ checked: false })

    this.Buscar(1);
  }


  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  checkAllChange({ checked }) {
    this.listaMovimientosAll.filter(p => p.envio_rec).forEach(mov => { mov.additionalInfo.checked = checked })
    this.listaMovimientos.filter(p => p.envio_rec).forEach(mov => { mov.additionalInfo.checked = checked })

    const dato = this.listaMovimientosAll.map(cliente => {
      console.log(cliente);
      cliente.rutFormato = this.rutService.AgregarDV(cliente.rut)
      // cliente.checked = false
      this.removeElementTypename(cliente)
      const params = {
        empresa_rut: cliente.empresa_rut,
        codigo_vendedor: cliente.codigo_vendedor,
        rut: cliente.rut,
        nombre: cliente.razon_social,
        activo: cliente.activo,
        codigo_direccion: cliente.codigo_direccion,
        direccion_completa: cliente.direccion_completa,
        nombrecomuna: cliente.nombrecomuna,
        nombreprovincia: cliente.nombreprovincia,
        ruta_codigo: cliente.ruta_codigo,
        ruta_nombre: cliente.ruta_nombre,
        territorio_codigo: cliente.territorio_codigo,
        tipo_cliente_codigo: cliente.tipo_cliente_codigo,
        tipo_cliente_nombre: cliente.tipo_cliente_nombre,
        seleccion: cliente.additionalInfo.checked,
        lunes: cliente.lunes,
        martes: cliente.martes,
        miercoles: cliente.miercoles,
        jueves: cliente.jueves,
        viernes: cliente.viernes,
        sabado: cliente.sabado,
        domingo: cliente.domingo,
      }

      return params
    });
    this.seleccionForTraspasoMasivo = dato;
    this.ClientesSeleccion = dato.filter(x => x.seleccion == true);

    this.handleAreSelected()
  }

  checkDetalle({ index }, { checked }) {
    const _indexAll = this.listaMovimientosAll.findIndex(p => p.additionalInfo.index === index)
    this.listaMovimientosAll[_indexAll].additionalInfo.checked = checked

    const _indexPage = this.listaMovimientos.findIndex(p => p.additionalInfo.index === index)
    this.listaMovimientos[_indexPage].additionalInfo.checked = checked

    // retorno todos los elementos checkeados para enviarlos a generar-ipt
    const dato = this.listaMovimientosAll.map(cliente => {
      cliente.rutFormato = this.rutService.AgregarDV(cliente.rut)
      // cliente.checked = false
      this.removeElementTypename(cliente)
      const params = {
        empresa_rut: cliente.empresa_rut,
        codigo_vendedor: cliente.codigo_vendedor,
        rut: cliente.rut,
        nombre: cliente.razon_social,
        activo: cliente.activo,
        codigo_direccion: cliente.codigo_direccion,
        direccion_completa: cliente.direccion_completa,
        nombrecomuna: cliente.nombrecomuna,
        nombreprovincia: cliente.nombreprovincia,
        ruta_codigo: cliente.ruta_codigo,
        ruta_nombre: cliente.ruta_nombre,
        territorio_codigo: cliente.territorio_codigo,
        tipo_cliente_codigo: cliente.tipo_cliente_codigo,
        tipo_cliente_nombre: cliente.tipo_cliente_nombre,
        seleccion: cliente.additionalInfo.checked,
        lunes: cliente.lunes,
        martes: cliente.martes,
        miercoles: cliente.miercoles,
        jueves: cliente.jueves,
        viernes: cliente.viernes,
        sabado: cliente.sabado,
        domingo: cliente.domingo,
      }

      return params
    });
    this.seleccionForTraspasoMasivo = dato;
    this.ClientesSeleccion = dato.filter(x => x.seleccion == true);

    this.handleAreSelected()
  }

  private removeElementTypename(register: any) {
    delete register.__typename
    return register
  }

  handleAreSelected() {
    if (!this.listaMovimientosAll || this.listaMovimientosAll.length == 0)
      this.areSelected = false
    this.selected = this.listaMovimientosAll.filter(mov => mov.additionalInfo.checked)
    this.areSelected = this.selected.length > 0
  }

}
